import { useCallback } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { setCorporalEvaluationImageIndex } from '~/modules/corporalEvaluation/services'
import { evaluationAtom } from '~/modules/evalutation/data'
import { patchEvaluationAtom } from '~/modules/evalutation/services'
import { useAtom } from '~/observers/jotai'

export const CoteWilmore: React.FC = () => {
  const [evaluation] = useAtom(evaluationAtom)

  const handleAbdomenFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(8)
  }, [])

  const handleRightFistFocus = useCallback(() => {
    setCorporalEvaluationImageIndex(9)
  }, [])

  return (
    <div className='flex gap-3'>
      <MaskedInput
        label='Abdômen (cm)'
        mask='float'
        placeholder='0,0'
        value={evaluation?.abdomen}
        onFocus={handleAbdomenFocus}
        onChange={(v) =>
          patchEvaluationAtom({
            abdomen: +v,
          })
        }
      />
      <MaskedInput
        key={'rightFist-input'}
        label='Punho Direito (cm)'
        mask='float'
        value={evaluation?.rightFist}
        placeholder='0,0'
        onFocus={handleRightFistFocus}
        onChange={(v) =>
          patchEvaluationAtom({
            rightFist: +v,
          })
        }
      />
    </div>
  )
}
